<template>
  <b-button size="md" variant="link" :style="{ backgroundColor: '#FFCA10', color: '#151515' }" class="ml-3" :to="to">
    <i class="fa fa-list" />
    View assignment
  </b-button>
</template>

<script lang="ts">
import { BButton } from 'bootstrap-vue-next'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { CUSTOMER_ASSIGNMENTS_DETAILS, STAFF_ASSIGNMENTS_DETAILS } from '@/types/router'

export default defineComponent({
  name: 'ViewAssignment',
  components: { BButton },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const accountStore = useAccountStore()

    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const assignmentRef: ComputedRef<string> = computed(() => assignmentSummaryStore.reference || '')
    const routeName: ComputedRef<string> = computed(() =>
      isStaff.value ? STAFF_ASSIGNMENTS_DETAILS : CUSTOMER_ASSIGNMENTS_DETAILS,
    )
    const to = computed(() => ({
      name: routeName.value,
      params: { id: assignmentRef.value },
    }))

    return {
      to,
    }
  },
})
</script>
